@file:OptIn(InternalResourceApi::class)

package nestbridge.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/nestbridge.composeapp.generated.resources/"

@delegate:ResourceContentHash(379_089_144)
internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_735_795_348)
internal val Res.drawable.ic_apple_logo: DrawableResource by lazy {
      DrawableResource("drawable:ic_apple_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_apple_logo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(703_591_449)
internal val Res.drawable.ic_google_logo: DrawableResource by lazy {
      DrawableResource("drawable:ic_google_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_google_logo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_049_822_986)
internal val Res.drawable.ic_nestbridge_logo: DrawableResource by lazy {
      DrawableResource("drawable:ic_nestbridge_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_nestbridge_logo.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("ic_apple_logo", Res.drawable.ic_apple_logo)
  map.put("ic_google_logo", Res.drawable.ic_google_logo)
  map.put("ic_nestbridge_logo", Res.drawable.ic_nestbridge_logo)
}
